import * as actionTypes from './actionTypes';
import initialState from 'store/initialState';

export default function(state = initialState.statusTracker, action) {
  switch (action.type) {
    case actionTypes.SET_STATUS_TRACKER_DATA:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/statusTracker/reducer.js